<template>
    <div class="RiskProfileSaveButton" :class="{'RiskProfileSaveButton--disabled': disabled}">
        <RbacDisplayGuard :features="[RbacFeature.decisioningSaveRiskProfileChanges]">
            <NewButton
                class="RiskProfileSaveButton__saveButton"
                color="primary"
                :class="{'RiskProfileSaveButton__saveButton--opened':opened}"
                :disabled="disabled"
                @click="$emit('saveActive')"
            >
                Publish changes
            </NewButton>
        </RbacDisplayGuard>
    </div>
</template>

<script lang="ts">
    import { defineComponent, PropType } from 'vue';

    import RbacDisplayGuard from '@evidentid/dashboard-commons/modules/role-base-access-control/components/rbac-guard/RbacDisplayGuard.vue';
    import { RbacFeature } from '@evidentid/tprm-portal-lib/models/rbac';

    import NewButton from '@/components/new-button/NewButton.vue';

    export default defineComponent({
        name: 'RiskProfileSaveButton',
        components: {
            NewButton,
            RbacDisplayGuard,
        },
        props: {
            disabled: {
                type: Boolean as PropType<boolean>,
                default: false,
            },
        },
        emits: [ 'saveActive' ],
        data() {
            return {
                opened: false,
                // Make RbacFeature available in template
                RbacFeature,
            };
        },
    });
</script>
